import React, { memo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

const EXTRA_PACK_SIZE = 25
const EXTRA_USAGE_PAYMENT_FORM_PATH = '/profile/subscription/extra-usage-payment-form'
const STUDIO_RETURN_URL = '/ai'
const BUY_EXTRA_USAGE_HREF =
  `${EXTRA_USAGE_PAYMENT_FORM_PATH}?return_url=${encodeURIComponent(STUDIO_RETURN_URL)}`

function ExtraUsageCard({ onClose: handleClose }) {
  const t = useTranslation()
  const extraGenerationsPrice = useThreeDStudioStore(state => state.subscription.extraGenerationsPrice)

  const title = extraGenerationsPrice
    ? t('usageModal.extraUsage.titleWithPrice', { count: EXTRA_PACK_SIZE, price: extraGenerationsPrice })
    : t('usageModal.extraUsage.title', { count: EXTRA_PACK_SIZE })

  return (
    <>
      <section className="usage-modal__extra-card">
        <div className="usage-modal__extra-card-copy">
          <p className="usage-modal__extra-card-title cgt-heading-50">
            {title}
          </p>
          <p className="usage-modal__extra-card-subtitle cgt-body-base">
            {t('usageModal.extraUsage.subtitle')}
          </p>
        </div>
        <Button
          size="small"
          type="primary"
          href={BUY_EXTRA_USAGE_HREF}
          onClick={handleClose}
        >
          {t('usageModal.extraUsage.cta')}
        </Button>
      </section>
      <p className="usage-modal__extra-card-note cgt-caption">
        {t('usageModal.extraUsage.note')}
      </p>
    </>
  )
}

ExtraUsageCard.propTypes = {
  onClose: func.isRequired,
}

export default memo(ExtraUsageCard)
